<template>
  <el-dialog
    :title="title"
    :visible.sync="openDesignDialog"
    :width="isPrint ? '40%' : '55%'"
    append-to-body
  >
    <div ref="printTable" id="print">
      <table class="table" border="1" cellspacing="0">
        <thead>
          <tr>
            <th colspan="1"></th>
            <th colspan="2" class="wid">商户名称</th>
            <td colspan="2">
              <input v-if="!isPrint" v-model="info.shopName" type="text" />
              <span v-else>{{ info.shopName }}</span>
            </td>
            <th colspan="2">商铺编号</th>
            <td colspan="2">
              <input v-if="!isPrint" v-model="info.shopNumber" type="text" />
              <span v-else>{{ info.shopNumber }}</span>
            </td>
            <th colspan="1">面积</th>
            <td colspan="1">
              <input v-if="!isPrint" v-model="info.shopArea" type="text" />
              <span v-else>{{ info.shopArea }}</span>
            </td>
          </tr>
          <!-- 营运部 -->
          <tr>
            <th rowspan="5" >
              <span class="vertical">运营部</span>
            </th>
          </tr>
          <tr>
            <th colspan="2">收图日期</th>
            <td colspan="2">
              <el-date-picker
                v-if="!isPrint"
                v-model="info.drawingReceipt"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <span v-else>{{ info.drawingReceipt }}</span>
              <!-- <input v-model="info.drawingReceipt" type="text" /> -->
            </td>
            <th colspan="1">审核日期</th>
            <td colspan="5">
              <el-date-picker
                v-if="!isPrint"
                v-model="info.approvalDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
              <span v-else>{{ info.approvalDate }}</span>
              <!-- <input v-model="info.approvalDate" type="text" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              效果图
              <el-checkbox
                v-model="info.effectPicture"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="1">
              平面
              <el-checkbox
                v-model="info.sysPlane"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="1">
              立面
              <el-checkbox
                v-model="info.sysFacade"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              节点大样
              <el-checkbox
                v-model="info.nodeSample"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              电气
              <el-checkbox
                v-model="info.electricAppliance"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              暖通
              <el-checkbox
                v-model="info.heatingVentilation"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              给排水
              <el-checkbox
                v-model="info.waterSupply"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              消防
              <el-checkbox
                v-model="info.fireControl"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              厨房
              <el-checkbox
                v-model="info.kitchen"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              材料单
              <el-checkbox
                v-model="info.billMeaterials"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="1">
              说明
              <el-checkbox
                v-model="info.explain"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="6"></td>
          </tr>
          <tr>
            <td colspan="10">
              <div class="explain">
                <span>以上设计资料中打√者为齐全</span>
                <span class="pad_rig"
                  >审核人：<input v-if="!isPrint" v-model="info.verifier" type="text" />
                  <span v-else>{{ info.verifier }}</span>
                </span>
              </div>
            </td>
          </tr>
          <!-- 规划与工程部 -->
          <tr>
            <th rowspan="10" class="vertical">规划与工程部</th>
          </tr>
          <tr>
            <td colspan="2">
              效果图
              <el-checkbox
                v-model="info.designSketch"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="8" rowspan="8" align="left" valign="top">
              <span
                >其他意见：

                <textarea v-if="!isPrint" v-model="info.otherOpinions" rows="14">
                </textarea>
                <span v-else>{{ info.otherOpinions }}</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              店面形象
              <el-checkbox
                v-model="info.storeImage"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              平面
              <el-checkbox
                v-model="info.planeFlat"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              天花
              <el-checkbox
                v-model="info.smallpox"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              地面铺装
              <el-checkbox
                v-model="info.foorPaving"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              立面
              <el-checkbox
                v-model="info.elevation"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              节点大样
              <el-checkbox
                v-model="info.nodeAppearance"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              与临浦衔接
              <el-checkbox
                v-model="info.connectWith"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <div class="explain">
                <span>以上设计资料中打√者为合格</span>
                <span class="pad_rig"
                  >审核人：
                  <input v-if="!isPrint" v-model="info.auditPerson" type="text" />
                  <span v-else>{{ info.auditPerson }}</span>
                </span>
              </div>
            </td>
          </tr>
          <!-- 物业管理处 -->
          <tr>
            <th rowspan="12" class="vertical">物业管理处</th>
          </tr>
          <tr>
            <td colspan="2" rowspan="2" align="center">电气</td>
            <td colspan="2">
              设计电量
              <el-checkbox
                v-model="info.designCapacity"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              强电系统
              <el-checkbox
                v-model="info.strongCurrent"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              照明
              <el-checkbox
                v-model="info.illumination"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              插座
              <el-checkbox
                v-model="info.outlet"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              弱电系统图
              <el-checkbox
                v-model="info.weakCurrent"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2">
              设备清单
              <el-checkbox
                v-model="info.deviceList"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2"></td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td colspan="2" align="center">暖通</td>
            <td colspan="2">
              送/回风口
              <el-checkbox
                v-model="info.paceWith"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2">
              风管
              <el-checkbox
                v-model="info.fluePipe"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2">
              水管
              <el-checkbox
                v-model="info.waterPipe"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2">
              检修口
              <el-checkbox
                v-model="info.checkHole"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
          </tr>
          <tr>
            <td colspan="2" align="center">给排水</td>
            <td colspan="2">
              给水走向
              <el-checkbox
                v-model="info.feedwater"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              排水走向
              <el-checkbox
                v-model="info.drainWater"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              给水点位
              <el-checkbox
                v-model="info.waterSupplyDrainage"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td colspan="2" rowspan="3" align="center">消防专项</td>
            <td colspan="2">
              应急照明
              <el-checkbox
                v-model="info.emergebcyLighting"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              逃生指示
              <el-checkbox
                v-model="info.escapeInstruction"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              喷淋系统
              <el-checkbox
                v-model="info.spraySystem"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              烟/温感
              <el-checkbox
                v-model="info.smokeTemperature"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              警告/广播
              <el-checkbox
                v-model="info.alarmBroadcast"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              排烟
              <el-checkbox
                v-model="info.ejectSmoke"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              防火卷帘
              <el-checkbox
                v-model="info.fireShutter"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              消防栓
              <el-checkbox
                v-model="info.fireChute"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              手报
              <el-checkbox
                v-model="info.personalNewspaper"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
            </td>
            <td colspan="2"></td>
            <td colspan="2"></td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td colspan="2" rowspan="2" align="center">厨房专项</td>
            <td colspan="2">
              隔油池
              <el-checkbox
                v-model="info.oilSeparator"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              油烟净化器
              <el-checkbox
                v-model="info.oilFume"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              不断电设备
              <el-checkbox
                v-model="info.uninterruptablePower"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              防水
              <el-checkbox
                v-model="info.waterProof"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
          </tr>
          <tr>
            <td colspan="2">
              燃气设备
              <el-checkbox
                v-model="info.gasEquipment"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2">
              燃气泄漏报警
              <el-checkbox
                v-model="info.gasLeak"
                :true-label="1"
                :false-label="0"
                :disabled="isPrint"
              ></el-checkbox>
              <!-- <input type="checkbox" name="" id="" /> -->
            </td>
            <td colspan="2"></td>
            <td colspan="2"></td>
          </tr>
          <tr>
            <td colspan="10" align="left" valign="top">
              <p>其他意见：</p>
              <!-- <input type="text" style="height: 200px;"> -->
              <textarea v-if="!isPrint" v-model="info.otherAdvice" rows="8"> </textarea>
              <span v-else>{{ info.otherAdvice }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <div class="explain">
                <span>以上设计资料中打√者为合格</span>
                <span class="pad_rig"
                  >审核人：<input
                    v-if="!isPrint"
                    v-model="info.checkPerson"
                    type="text"
                  />
                  <span v-else>{{ info.checkPerson }}</span>
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="3">部门负责人</th>
            <td colspan="4">
              规划与工程部:<input
                v-if="!isPrint"
                v-model="info.departmentHead"
                type="text"
              />
              <span v-else>{{ info.departmentHead }}</span>
            </td>
            <td colspan="4">
              物业管理处：<input
                v-if="!isPrint"
                v-model="info.propertyManager"
                type="text"
              />
              <span v-else>{{ info.propertyManager }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="3">商户意见</th>
            <td colspan="8">
              <div class="explain">
                <span></span>
                <span class="pad_rig"
                  >签字：<input
                    v-if="!isPrint"
                    v-model="info.customerFeedback"
                    type="text"
                  />
                  <span v-else>{{ info.customerFeedback }}</span>
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="3">商管公司总经理室意见</th>
            <td colspan="3">
              签字：<input v-if="!isPrint" v-model="info.companyFeedback" type="text" />
              <span v-else>{{ info.companyFeedback }}</span>
            </td>
            <th colspan="3">物业公司总经理室意见</th>
            <td colspan="3">
              签字：<input v-if="!isPrint" v-model="info.realEstate" type="text" />
              <span v-else>{{ info.realEstate }}</span>
            </td>
          </tr>
          <tr>
            <th colspan="3">甲方意见</th>
            <td colspan="8">
              <!-- <input v-model="info.firstParty" type="text" /> -->
              <div class="explain">
                <span></span>
                <span class="pad_rig"
                  >签字：<input v-if="!isPrint" v-model="info.firstParty" type="text" />
                  <span v-else>{{ info.firstParty }}</span>
                </span>
              </div>
            </td>
          </tr>
        </thead>
      </table>
    </div>
    <el-upload
      class="avatar-uploader"
      action="/api/safe/design/uploadRoomPictureFile"
      list-type="picture-card"
      :on-success="handleAvatarSuccess"
      :headers="headerData"
      name="file"
      accept=".jpg,.jpeg,.png"
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :on-preview="handlePictureCardPreview"
      multiple
      :limit="10"
      :file-list="imgFileList"
      :disabled="isPrint"
    >
      <!-- <img v-if="info.showPath" :src="info.showPath" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <div class="el-upload__tip" slot="tip">
        只能上传jpg/png/jpeg文件，且不超过5MB
      </div> -->
      <i class="el-icon-plus"></i>
      <div class="el-upload__tip" slot="tip">
        只能上传jpg/png文件，最多上传10张且单张图片不超过10M
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="isPrint" type="primary" :loading="printLoading" @click="onPrint"
        >打印</el-button
      >
      <el-button @click="cancel">取 消</el-button>
      <el-button v-if="!isPrint" type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import html2canvas from "html2canvas";
import printJs from "print-js";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},
  data() {
    return {
      info: {
        
      },
      finishPicture: [],
      showPathUrl: [],
      dialogVisible: false,
      dialogImageUrl: "",
      isPrint: false,
      imgFileList: [],
      // 弹出层标题
      title: "",
      // 是否显示打印
      id: "",
      // 是否显示弹出层
      openDesignDialog: false,
      printLoading: false,
      headerData: {
        Authorization: localStorage.access_token,
      },
    };
  },
  // 监听属性类似于data概念
  computed: {
    
  },
  // 方法集合
  methods: {
    // 重置
    reset() {
      this.info = {};
      this.finishPicture = [];
      this.showPath = [];
      this.imgFileList = [];
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.id = "";
      this.isPrint = false;
      this.openDesignDialog = true;
      this.reset();
      this.title = "新增";
    },
    handleView(id) {
      this.isPrint = true;
      this.$http.get(`/api/safe/design/${id}`).then((res) => {
        this.info = res.data.data;
        if (res.data.data.showPathUrl && res.data.data.showPathUrl.length) {
          this.imgFileList = res.data.data.showPathUrl.map(e => {
            return {
              url: e.showPath,
              ...e
            }
          })
        }
        this.openDesignDialog = true;
        this.title = "查看";
      });
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      // console.log(id, "22");
      this.isPrint = false;
      this.id = id;
      this.$http.get(`/api/safe/design/${id}`).then((res) => {
        this.openDesignDialog = true;
        this.title = "修改";
        this.info = res.data.data;
        this.imgFileList = res.data.data.showPathUrl.map(e => {
          return {
            url: e.showPath,
            ...e
          }
        })
        // console.log(this.imgFileList);
      });
    },
    /** 提交按钮 */
    submitForm() {
      const { shopName, shopNumber, shopArea } = this.info
      if (!shopName) {
        this.$message.warning('请填写商户名称')
        return
      } else if(!shopNumber) {
        this.$message.warning('请填写商铺编号')
        return
      } else if(!shopArea) {
        this.$message.warning('请填写商铺面积')
        return
      }
      this.info.showPathUrl = this.showPathUrl
      if (!this.info.id) {
        this.$http.post("/api/safe/design", this.info).then((response) => {
          this.$message.success("新增成功");
          (this.openDesignDialog = false), 
          this.$emit('getList')
          // this.getList();
        });
      } else {
        this.$http.put("/api/safe/design", this.info).then(() => {
          this.$message.success("修改成功");
          (this.openDesignDialog = false), 
          this.$emit('getList')
          // this.getList();
        });
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      var isJPG = null;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        isJPG = true;
      } else {
        isJPG = false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("只能上传 JPG/JPEG/PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt10M && isJPG;
    },
    //删除图片时
    handleRemove(file, fileList) {
      // console.log(fileList, "fileList");
      // const finishPicture = [];
      // const showPath = [];
      // fileList.forEach((e) => {
      //   if (!this.info.id) {
      //     showPath.push(e.response.data.showPath);
      //     finishPicture.push(e.response.data.filePath);
      //   } else {
      //     showPath.push(e.url);
      //     finishPicture.push(e.url);
      //   }
      // });
      this.showPathUrl = fileList.map(e => {
        return {
          showPath: e.showPath,
          finishPicture: e.filePath
        }
      })
      // console.log(this.showPathUrl, '222');
      // this.info.finishPictureUrl = finishPicture;
      // this.info.showPathUrl = showPath;
    },
    //文件超出个数限制时
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 取消按钮
    cancel() {
      this.reset();
      this.openDesignDialog = false;
    },
    // 上传成功
    handleAvatarSuccess(file, fileList) {
      // this.finishPicture.push(file.data.filePath);
      // this.showPath.push(file.data.showPath);
      const obj = {
        showPath: file.data.showPath,
        finishPicture: file.data.filePath
      }
      // console.log(obj, '222');
      this.showPathUrl.push(obj)
      // // if (this.info.id) {
      //   const list = this.info.finishPictureUrl;
      //   list.forEach((e) => {
      //     this.imgFileList.forEach((v) => {
      //       if (e === v) {
      //       }
      //     });
      //   });
      // } else {
      //   this.info.finishPictureUrl = this.finishPicture;
      //   this.info.showPathUrl = this.showPath;
      // }
      // console.log(file, fileList,this.showPathUrl, "im2");
    },
    onPrint() {
      this.printLoading = true;
      const printContent = this.$refs.printTable;
      const width = printContent.clientWidth;
      const height = printContent.clientHeight;
      const canvas = document.createElement("canvas");
      const scale = 4;

      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.style.width = width * scale + "px";
      canvas.style.height = height * scale + "px";
      canvas.getContext("2d").scale(scale, scale);

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;

      html2canvas(printContent, {
        canvas,
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight,
        scrollX: -scrollLeft,
        scrollY: -scrollTop,
      })
        .then((canvas) => {
          const url = canvas.toDataURL("image/png");
          // console.log(url, 222);
          this.printLoading = false
          setTimeout(() => {
            printJs({
              printable: url,
              type: "image",
              documentTitle: "",
              style: "@page{size:auto;margin: 0cm 1cm 0cm 1cm;}",
            });
          }, 100);
        })
        .catch((err) => {
          // console.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none;
}
input {
  border: transparent; /* 移除输入框的边框 */
  outline: none; /* 移除输入框的聚焦边框 */
}
table {
  table-layout: fixed;
}
.explain {
  display: flex;
  justify-content: space-between;
}

.vertical {
  width: 2em; /* 调整这个值以适应单行文本的宽度 */
}
.el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
}
tr td {
  padding: 5px;
}

th {
  padding: 10px;
  background-color: #b4b0c7;
}

textarea {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
}
.pad_rig {
  padding-right: 100px;
}
.wid {
  width: 125px;
}
.print {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
